import * as yup from 'yup';

// Radio values mirror the server's SalaryType enum
// (BevNET.Core.Domain/Enums/SalaryType.cs): 1 = ExactCompensation,
// 2 = SpecifyRange, 3 = DoNotProvide.
const DO_NOT_PROVIDE = 3;

const locationItem = yup.object().shape({
  isShowState: yup.boolean(),
  country: yup.string().nullable(),
  address1: yup.string().nullable(),
  address2: yup.string().nullable(),
  state: yup.string().nullable()
    .when('isShowState', {
      is: true,
      then: yup.string().required('Required').nullable(),
      otherwise: yup.string().nullable()
    }),
  province: yup.string().nullable(),
  zip: yup.string().nullable(),
  city: yup.string().nullable().required('Required'),
});

export const schema:any = yup.object().shape({
  // Server: RuleFor(x => x.Step3.SalaryUnitId).NotEmpty()
  //           .When(x => x.Step3.SalaryUnitRadio != SalaryType.DoNotProvide)
  // NotEmpty() on an `int?` rejects null only (0 is a legal id there), so the
  // client mirror is required(), not min(1).
  salaryUnitId: yup.number().nullable().when('salaryUnitRadio', {
    is: (value: number) => value !== DO_NOT_PROVIDE,
    then: yup.number().nullable().required('The Specify Compensation Per field is required.'),
    otherwise: yup.number().nullable()
  }),

  showSalaryExact: yup.boolean(),

  salaryMin: yup.number().nullable().when('salaryUnitRadio', {
    is: 2,
    then: yup.number().required('Required').nullable(),
    otherwise: yup.number().nullable()
  }),
  salaryMax: yup.number().nullable().when('salaryUnitRadio', {
    is: 2,
    then: yup.number().required('Required').nullable(),
    otherwise: yup.number().nullable()
  }),
  salaryExact: yup.number().nullable()
    .when('showSalaryExact', {
      is: true,
      then: yup.number().required('The Salary Exact field is required.').nullable(),
      otherwise: yup.number().nullable()
    }),
  noneLocation: yup.boolean(),
  salaryUnitRadio: yup.number(),

  // Server: RuleFor(x => x.Step3.Locations).NotEmpty().When(x => x.Step3.NoneLocation == false)
  // Only the per-item rules existed here, so a non-remote job with zero locations
  // passed the client and was rejected by the server. Reachable: a restored draft
  // carrying noneLocation:false with an empty locations array renders no rows at all.
  // The array-level message is rendered by Step3 itself (the rows only render
  // errors.locations[index], so it would otherwise block Next with nothing on screen).
  locations: yup.array().of(locationItem).when('noneLocation', {
    is: false,
    then: yup.array().of(locationItem).min(1, 'Please add at least one job location, or mark this job as remote.'),
    otherwise: yup.array().of(locationItem)
  })
});
